/*
 * @Description:
 * @Version: 2.0
 * @Autor: ShiChangZhan
 * @Date: 2021-08-27 12:41:37
 * @LastEditors: ShiChangZhan
 * @LastEditTime: 2021-09-09 14:24:48
 */
import { Toast } from 'vant'
export class CopyText {
  // Copy a string to user's clipboard
  copyToClipboard(text) {
    let copyText = document.createElement('input')
    document.body.appendChild(copyText)
    copyText.value = text
    copyText.select()
    document.execCommand('copy')
    document.body.removeChild(copyText)
    Toast('复制成功')
  }
}
//滚动容器,被滚动容器,滚动到底部要执行的方法
export const addListenScroll=(container,wrapper,fn)=>{
  // console.log('container',container,'wrapper',wrapper);
  //监听内容页面滚动
  container.addEventListener("scroll", (e) => {
    if(e.target.scrollTop == 0) {
      return
    }
    let bottomOfWindow =
      wrapper.offsetHeight -
      e.target.scrollTop -
      container.offsetHeight;
    bottomOfWindow = bottomOfWindow || 0;
    // console.log(bottomOfWindow);
    if (bottomOfWindow && bottomOfWindow <30) {
        fn()
    }
  });
}


// utils.js
export function getShareUrl(path, query = {}) {
  const baseHref = process.env.VUE_APP_H5 || ''; // 确保 baseHref 存在
  const appPath = (process.env.VUE_APP_TYPE_NAME || '').toLowerCase(); // 获取应用类型

  // 处理 query 参数
  const queryString = Object.keys(query)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`)
    .join('&');

  // 确保 path 以 `/` 开头
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  // 如果 `appPath` 不是空的，则追加到 `baseHref` 后
  const finalBaseHref = appPath ? `${baseHref}/${appPath}` : baseHref;

  // 拼接最终的 `shareUrl`
  return `${finalBaseHref}${normalizedPath}${queryString ? '?' + queryString : ''}`;
}


export function isValidId(val) {
  return val !== null && !isNaN(val) && Number(val) > 0;
}



// WEBPACK FOOTER //
// ./src/utils/utils.js